import { useState } from "react";
import { BellRing } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const ALERTS = [
  { k: "notify_deposits", title: "Email me when a deposit hits Spending", desc: "Paychecks, bank transfers and card deposits — with how the money was split into bills, savings and bill locks." },
  { k: "notify_purchases", title: "Email me each time my card is used", desc: "Merchant, amount and how much Spending you have left — sent the moment the swipe is authorized." },
  { k: "notify_forecast", title: "Email me two days before payday", desc: "Your predicted paycheck, what leaves for vaults and bills, and what's really yours." },
];

function Row({ item, initial }) {
  const { refresh } = useAuth();
  const [on, setOn] = useState(initial);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const toggle = async () => {
    const next = !on;
    setOn(next); setBusy(true); setErr("");
    try { await api.patch("/auth/profile", { [item.k]: next }); refresh(); }
    catch (e) { setOn(!next); setErr(formatErr(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  const tid = item.k.replace("notify_", "notify-");
  return (
    <div className="py-4 border-t border-sand first:border-t-0 first:pt-0" data-testid={`${tid}-row`}>
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <div className="font-medium text-ink">{item.title}</div>
          <p className="text-xs text-moss mt-1 max-w-md">{item.desc}</p>
        </div>
        <button type="button" role="switch" aria-checked={on} onClick={toggle} disabled={busy}
          className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors disabled:opacity-60 ${on ? "bg-forest" : "bg-sand"}`}
          data-testid={`${tid}-toggle`}>
          <span className={`inline-block h-5 w-5 rounded-full bg-white shadow transition-transform ${on ? "translate-x-6" : "translate-x-1"}`} />
        </button>
      </div>
      <div className="mt-1 text-xs text-sage" data-testid={`${tid}-state`}>{on ? "On" : "Off"}</div>
      {err && <div className="mt-1 text-sm text-clay" data-testid={`${tid}-error`}>{err}</div>}
    </div>
  );
}

export default function NotificationsCard() {
  const { user } = useAuth();
  return (
    <div className="mt-6 bg-linen border border-sand rounded-2xl p-8" data-testid="notifications-section">
      <div className="text-xs uppercase tracking-[0.2em] font-semibold text-sage inline-flex items-center gap-1.5"><BellRing className="w-3.5 h-3.5" /> Notifications</div>
      <p className="text-xs text-moss mt-2">Sent to <span className="font-mono">{user?.email}</span>.</p>
      <div className="mt-4">
        {ALERTS.map((a) => <Row key={a.k} item={a} initial={user?.[a.k] !== false} />)}
      </div>
    </div>
  );
}
